import { Controller } from "@hotwired/stimulus"

// The right-rail "What to say" phone script. Purely local UI state: the main
// line renders by default, an objection pill swaps in its rebuttal script and
// marks itself pressed, and "back to main line" restores the main script and
// returns focus to the pill that opened the branch. Clicking a pressed pill
// also returns to the main line. Nothing here persists or talks to the server.
//
// The active branch is derived from the DOM (the non-hidden script panel), so
// a Turbo-cache restore keeps whatever branch was showing and connect() only
// re-synchronizes the pills' pressed state to it.
export default class extends Controller {
  static targets = ["script", "objection"]

  connect() {
    this.show(this.activeKey())
  }

  select(event) {
    const key = event.currentTarget.dataset.scriptKey
    this.show(this.activeKey() === key ? "main" : key)
  }

  back() {
    const branchKey = this.activeKey()
    this.show("main")
    // The back button just disappeared with its panel; land focus on the pill
    // that opened the branch so keyboard position is preserved.
    this.objectionTargets.find((pill) => pill.dataset.scriptKey === branchKey)?.focus()
  }

  activeKey() {
    return this.scriptTargets.find((panel) => !panel.hidden)?.dataset.scriptKey || "main"
  }

  show(key) {
    this.scriptTargets.forEach((panel) => { panel.hidden = panel.dataset.scriptKey !== key })
    this.objectionTargets.forEach((pill) => {
      pill.setAttribute("aria-pressed", String(pill.dataset.scriptKey === key))
    })
  }
}
